var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1198_9168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 167,
    height: 168
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rwing",
    d: "M169.934 80.104L157.846 111.692L115.846 69.6921L126.461 23.0769L169.934 80.104Z",
    fill: "url(#paint0_linear_1198_9168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lwing",
    d: "M79.4496 170.59L108.924 160.615L66.9244 118.615L23.0784 126.461L79.4496 170.59Z",
    fill: "url(#paint1_linear_1198_9168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "burner",
    d: "M47.0781 78.4609L77.5395 47.9995L64.6165 38.7688L38.7705 64.6148L47.0781 78.4609Z",
    fill: "url(#paint2_linear_1198_9168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.234 143.077L91.7388 93.5821L82.7718 84.6151L73.8048 75.6481L67.8268 69.6701L62.545 64.3883L61.8489 63.6921L62.197 63.344L62.545 62.9959L80.0014 45.5396L80.6976 44.8434L81.3938 45.5396L85.9794 50.1252L86.6756 50.8214L87.3718 50.1252L93.792 43.705L94.4882 43.0088L95.1844 43.705L99.77 48.2906L100.466 48.9868L101.162 48.2906L107.132 42.3214C119.081 52.7896 130.284 62.9709 139.597 74.1192C154.089 91.4674 166.698 109.164 177.319 131C193.362 163.982 189.126 183.612 187.74 188.191C187.677 188.398 187.621 188.574 187.572 188.719C187.458 189.059 187.387 189.23 187.387 189.23L186.619 188.462L170.77 172.613C170.834 172.551 170.898 172.488 170.961 172.424C171.131 172.255 171.296 172.083 171.459 171.91L186.945 187.396C187.098 186.844 187.272 186.137 187.445 185.276C187.93 182.85 188.395 179.202 188.292 174.37C188.086 164.71 185.608 150.291 176.434 131.431C165.858 109.688 153.3 92.0584 138.842 74.7504C129.762 63.8812 118.862 53.9222 107.176 43.6695L101.162 49.6829L100.466 50.3791L99.77 49.683L94.4882 44.4011L87.3718 51.5176L86.6756 52.2138L85.9794 51.5176L80.6976 46.2358L63.2412 63.6921L68.523 68.9739L74.501 74.9519L83.468 83.9189L92.435 92.8859L141.937 142.388C141.764 142.551 141.592 142.717 141.423 142.886C141.359 142.949 141.296 143.013 141.234 143.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.772 84.6159L73.805 75.6489L67.827 69.6709L61.849 63.693L43.5097 82.0323L49.4877 88.0102L41.8862 95.6117L47.8642 101.59L41.379 108.075C51.8672 120.004 62.0624 131.194 73.1859 140.531C90.4954 155.062 108.123 167.74 129.808 178.512C167.501 197.239 187.387 189.231 187.387 189.231L170.77 172.614C162.599 180.582 149.516 180.519 141.422 172.425C133.329 164.332 133.266 151.249 141.234 143.078L91.739 93.5829L82.772 84.6159Z",
    fill: "url(#paint3_linear_1198_9168)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1198_9168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 299",
    opacity: 0.7,
    width: 225.363,
    height: 225.363,
    transform: "matrix(1 0 0 -1 5.48438 223.877)",
    fill: "url(#paint4_linear_1198_9168)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1198_9168",
    x1: 214.886,
    y1: 52.1111,
    x2: 127.229,
    y2: 115.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C233E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDFD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1198_9168",
    x1: -26.8919,
    y1: 176.209,
    x2: 102.546,
    y2: 199.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C233E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDFD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1198_9168",
    x1: 173.644,
    y1: 58.5264,
    x2: 160.9,
    y2: 14.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDFD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1198_9168",
    x1: 170.771,
    y1: 205.846,
    x2: 134.968,
    y2: 88.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F548F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDFD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1198_9168",
    x1: -15.1687,
    y1: 43.5037,
    x2: 72.1616,
    y2: 47.8874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296795,
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635281,
    stopColor: "#8168FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971458,
    stopColor: "#FFA0EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7501dffc914c003818d330c66c9123c9.svg";
export { ForwardRef as ReactComponent };